
import { defineComponent } from "vue";
import LTagLinkName from "./LTagLinkName.vue";
import { mapMutations, mapState } from "vuex";

export default defineComponent({
  name: "LHomeFooter",
  components: { LTagLinkName },
  computed: {
    ...mapState(["links"]),
  },
  methods: {
    ...mapMutations(["setLinks"]),

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    updateLinks(value: any) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const newArr = this.links.filter((l: any) => l._id != value._id);
      this.setLinks(newArr);
    },
  },
});
